/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconCog.vue?vue&type=template&id=1938009c"
import script from "./IconCog.vue?vue&type=script&lang=js"
export * from "./IconCog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1938009c')) {
      api.createRecord('1938009c', component.options)
    } else {
      api.reload('1938009c', component.options)
    }
    module.hot.accept("./IconCog.vue?vue&type=template&id=1938009c", function () {
      api.rerender('1938009c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconCog.vue"
export default component.exports